import { FC } from 'react';
import { IntlFormattedMessage } from 'src/common/components/IntlFormattedMessage';
import { media } from 'src/common/styles/breakpoints';
import { typography } from 'src/common/styles/typography';
import styled, { css } from 'styled-components';

const Description = styled.h2`
  margin: 1.5rem 0;
  font-size: 1rem;
  font-weight: 400;
  color: ${({ theme }) => theme.text.secondary};
  font-family: ${typography.fontFamilyDefault};

  ${media.w.min.px576(css`
    font-size: 1rem;
  `)};
`;

const Title = styled.h1`
  font-family: ${typography.fontFamilyDefault};
  font-size: 2.5rem;
  line-height: 2.6875rem;
  font-weight: bold;
  color: ${({ theme }) => theme.text.primary};
  margin-top: 2.375rem;

  ${media.w.min.px576(css`
    font-size: 4.75rem;
    margin-top: 6.5rem;
    line-height: 5rem;
  `)}
`;

interface HeadingProps {
  headingMsgId: MessageId;
  descriptionMsgId?: MessageId;
}

const Heading: FC<HeadingProps> = ({ headingMsgId, descriptionMsgId }) => {
  return (
    <>
      <Title>
        <IntlFormattedMessage id={headingMsgId} />
      </Title>
      {descriptionMsgId && (
        <Description>
          <IntlFormattedMessage id={descriptionMsgId} />
        </Description>
      )}
    </>
  );
};

export default Heading;
